export default "static/src/images/Diplomatici-small.png";